function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.202 6.148c-2.876 4.952-.521 8.917.271 10.02-.965 1.799-1.707 3.779-1.966 5.858a.861.861 0 00.847.974.858.858 0 00.845-.757c.858-6.868 7.881-12.867 8.913-13.715.27-.06.775-.085 1.026.448.2.428.069.729.016.82-4.305 4.135-6.173 6.984-5.402 8.242a.88.88 0 00.75.407c3.128-.1 5.49-1.234 7.021-3.373C18.18 9.971 15.666 1.002 15.557.623a.858.858 0 00-.605-.595.846.846 0 00-.813.222c-1.514 1.517-3.365 1.843-5.326 2.188-2.44.428-4.965.873-6.611 3.71z",
  fill: "#F2F2F2"
});

function SvgGrayLeaf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgGrayLeaf;